/** Multi-tenant foundation — single centre in demo; keys scoped for future backend migration. */

export const DEFAULT_CENTRE_ID = 'centre-demo-1';

const ACTIVE_CENTRE_KEY = 'garderie-active-centre-id';

export function getActiveCentreId(): string {
  if (typeof window === 'undefined') return DEFAULT_CENTRE_ID;
  try {
    return localStorage.getItem(ACTIVE_CENTRE_KEY) ?? DEFAULT_CENTRE_ID;
  } catch {
    return DEFAULT_CENTRE_ID;
  }
}

export function setActiveCentreId(centreId: string): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(ACTIVE_CENTRE_KEY, centreId);
    window.dispatchEvent(new CustomEvent('garderie:centre-changed', { detail: centreId }));
  } catch {
    // ignore
  }
}

/** Prefix localStorage keys by active centre (new services use this). */
export function centreStorageKey(baseKey: string): string {
  return `garderie:${getActiveCentreId()}:${baseKey}`;
}

export interface CentreRecord {
  centreId: string;
}

export function withCentreId<T extends CentreRecord>(record: Omit<T, 'centreId'>): T {
  return { ...record, centreId: getActiveCentreId() } as T;
}

export function belongsToActiveCentre(record: { centreId?: string }): boolean {
  return !record.centreId || record.centreId === getActiveCentreId();
}
